import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerUrlService } from './server-url.service';

@Injectable({
  providedIn: 'root'
})
export class ProcedimentosService {

  procedimentoAnexos: Blob[] | undefined = []

  constructor(
    private http: HttpClient,
    private serverUrlService: ServerUrlService
  ) { }

  consultaProcedimentos(query: any) {
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    };

    const url = `${this.serverUrlService.getUrl()}/procedimentos/convenio_agendas`;
    return this.http.post(url, query, options);
  }

  consultaProfissionais(query: any) {
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    };

    const url = `${this.serverUrlService.getUrl()}/procedimentos/profissionais`;
    return this.http.post(url, query, options);
  }

  consultaValor(query: any) {
    const { user, host } = query;

    const queryObj = {
      sessionid: '0DC317B7F5219A9B308B92D7D1E4385D9999',
      usuarioid: user,
      acao: 'consultaValor',
      host,
      JSON: JSON.stringify(query)
    };
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    };

    const url = `${this.serverUrlService.getUrl()}/procedimentos/valor`;
    return this.http.post(url, queryObj, options);
  }
}
